import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import * as FilterUtilities from '../../../../_common/platform/tsx/filtering/FilterUtilities';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import SelectField from '../../../../_common/platform/ts/SelectField';

function getButtonShowModeVar(id: string, title: string, section: string, glob: IGlob) {
    return {
        id: id,
        param: new SelectField(glob, title, [], 'icon', {
            values: ['icon', 'text', 'iconAndText'],
            display: ['Icon', 'Text', 'Icon and Text']
        }),
        section: section
    };
}

export default function init(
    glob: IGlob,
    themeID: string,
    moduleName: string,
    section: string,
    justifyButtonsID: string,
    showResetButtonID: string,
    resetButtonShowModeID: string,
    showApplyButtonID: string,
    showRefreshButtonID: string,
    refreshButtonShowModeID: string,
    buttonsPositionID?: string,
    resetButtonModeID?: string,
    showBackButton?: string,
    backButtonShowModeID?: string,
    showFullScreenButton?: string,
    fullScreenButtonShowModeID?: string
) {
    const workspaceLevel = moduleName == null;

    appTheme.registerSections([
        {
            id: section,
            name: 'Buttons',
            parent: themeID,

            themeType: 'Buttons',
            visibility: workspaceLevel ? ['application', 'workspace'] : ['application', 'workspace', moduleName]
        }
    ]);

    appTheme.registerVars([
        {
            id: justifyButtonsID,
            param: new BooleanField(glob, 'Justify Buttons', [], false),
            section: section
        },
        {
            id: showResetButtonID,
            param: new BooleanField(glob, 'Show Reset', [], !workspaceLevel),
            section: section
        },
        getButtonShowModeVar(resetButtonShowModeID, 'Reset Button Show Mode', section, glob)
    ]);

    if (resetButtonModeID != null) {
        appTheme.registerVars([
            {
                id: resetButtonModeID,
                param: new SelectField(glob, 'Reset Button Mode', [], 'local', {
                    values: ['local', 'global'],
                    display: ['Reset Fitlers in this widget only', 'Reset all Filters']
                }),
                section: section
            }
        ]);
    }

    appTheme.registerVars([
        {
            id: showApplyButtonID,
            param: new BooleanField(glob, 'Show Apply', [], (theme) => {
                if (workspaceLevel) {
                    return false;
                }

                const applyMode = theme['workspace-apply-mode'];

                return applyMode == null ? null : applyMode !== FilterUtilities.ApplyModes.AUTO;
            }),
            section: section,
            deps: ['workspace-apply-mode']
        },
        {
            id: showRefreshButtonID,
            param: new BooleanField(glob, 'Show Refresh', [], workspaceLevel),
            section: section
        },
        getButtonShowModeVar(refreshButtonShowModeID, 'Refresh Button Show Mode', section, glob)
    ]);

    if (showBackButton != null) {
        appTheme.registerVars([
            {
                id: showBackButton,
                param: new BooleanField(glob, 'Show Back', [], false),
                section: section
            },
            getButtonShowModeVar(backButtonShowModeID, 'Back Button Show Mode', section, glob)
        ]);
    }
    if (showFullScreenButton != null) {
        appTheme.registerVars([
            {
                id: showFullScreenButton,
                param: new BooleanField(glob, 'Show Full Screen', [], false),
                section: section
            },
            getButtonShowModeVar(fullScreenButtonShowModeID, 'Full Screen Button Show Mode', section, glob)
        ]);
    }

    if (buttonsPositionID != null) {
        appTheme.registerVars([
            {
                id: buttonsPositionID,
                param: new SelectField(glob, 'Position', [], 'top', {
                    values: ['top', 'bottom'],
                    display: ['top', 'bottom']
                }),
                section: section
            }
        ]);
    }
}
